import { Link, useParams } from "react-router-dom";
import FadeInWrapper from "../components/FadeInWrapper";
import { useLanguage } from "../contexts/LanguageContext";
import { getTranslation } from "../translations";
import "./CareerDetail.css";

// Map URL slug to translation key(s)
const slugToKey = {
  "mechanical-design": "mechanicalDesign",
  "electronics-hardware": "electronicsHardware",
  "robot-software": "robotSoftware",
  "robot-ai-engineer-1": "robotAIEngineer1",
  "robot-ai-engineer-2": "robotAIEngineer2",
  "robot-control": "robotControl",
  "firmware": "firmware",
};

const formatTitle = (title) => {
  if (!title) return title;
  const parts = title.split(/([①②])/g);
  return parts.map((part, index) => {
    if (part === '①' || part === '②') {
      return <span key={index} className="circled-number">{part}</span>;
    }
    return part;
  });
};

function CareerDetail() {
  const { slug } = useParams();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const translationKey = slugToKey[slug];
  // Fetch the job object from translations
  // Note: getTranslation returns the object if the key points to an object in index.js
  const job = t(`careerDetails.${translationKey}`);

  // If job is missing or just returned the key string because it wasn't found
  // (We check if 'title' exists to verify it's a valid object)
  if (!job || typeof job !== "object" || !job.title) {
    return (
      <div className="page career-detail-page">
        <div className="career-detail-container">
          <Link to="/careers" className="career-back-link">
            &lt; 목차로 돌아가기
          </Link>
          <h1 className="career-detail-title">포지션을 찾을 수 없습니다</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="page career-detail-page">
      <div className="career-detail-container">
        <FadeInWrapper>
          <Link to="/careers" className="career-back-link">
            &lt; {language === 'ko' ? '목차로 돌아가기' : 'Back to List'}
          </Link>
          <h1 className="career-detail-title">{formatTitle(job.title)}</h1>

          <div className="career-detail-content">
            {/* Left Column - Job Description */}
            <div className="career-detail-left">
              {job.sections &&
                job.sections.map((section, index) => (
                  <div key={index} className="career-section">
                    <h3 className="career-section-title">{section.title}</h3>
                    {section.content && (
                      <p className="career-section-text">{section.content}</p>
                    )}
                    {section.list && (
                      <ul className="career-section-list">
                        {section.list.map((item, i) => (
                          <li key={i}>
                            {typeof item === "string" ? (
                              item
                            ) : (
                              <>
                                <span>{item.text}</span>
                                {item.subList && (
                                  <ul className="career-sub-list">
                                    {item.subList.map((subItem, j) => (
                                      <li key={j}>{subItem}</li>
                                    ))}
                                  </ul>
                                )}
                              </>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
            </div>

            {/* Right Column - Job Info */}
            <div className="career-detail-right">
              <p className="career-info-item">{job.type}</p>
              <p className="career-info-item">{job.location}</p>
              <p className="career-info-item">{job.openings}</p>
            </div>
          </div>
        </FadeInWrapper>
      </div>
    </div>
  );
}

export default CareerDetail;
